import { render, staticRenderFns } from "./EducationSurvey.vue?vue&type=template&id=70623e8a&scoped=true"
import script from "./EducationSurvey.vue?vue&type=script&lang=js"
export * from "./EducationSurvey.vue?vue&type=script&lang=js"
import style0 from "./EducationSurvey.vue?vue&type=style&index=0&id=70623e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70623e8a",
  null
  
)

export default component.exports